function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M40.2708 24.2994C39.1146 22.945 38.5871 21.773 38.5798 19.7853L38.5773 19.1095C38.5677 16.5193 37.9679 14.8481 36.6712 13.1744C34.6725 10.5751 31.3181 9.00047 28.04 8.98819L27.9006 8.98767C24.6914 8.97565 21.4532 10.4539 19.4388 12.9329C18.0841 14.6302 17.428 16.3683 17.4378 19.0303L17.4403 19.7061C17.4477 21.6938 16.9634 22.862 15.7827 24.2076C14.914 25.199 14.6399 26.4764 14.6451 27.8599C14.6502 29.2451 15.1077 30.5587 16.02 31.6284C17.2104 32.9112 18.8877 33.7336 20.5986 33.8819C23.0758 34.1749 25.5524 34.291 28.0647 34.3004C30.5754 34.3098 33.0509 34.1406 35.5279 33.9378C37.2361 33.8024 38.9074 32.9925 40.0883 31.7186C40.9912 30.6556 41.4406 29.3455 41.4355 27.9603C41.4303 26.5767 41.1468 25.2973 40.2708 24.2994Z",
  fill: "#67EDFF"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M31.2141 36.4171C30.4263 36.2455 25.6294 36.228 24.8428 36.3939C24.1704 36.5475 23.444 36.9078 23.4468 37.704C23.4887 38.4636 23.934 39.1355 24.549 39.5629L24.5475 39.5645C25.3432 40.1883 26.2758 40.5866 27.2513 40.7318C27.7712 40.8054 28.3002 40.8041 28.8383 40.7376C29.8112 40.5995 30.741 40.208 31.5323 39.5899L31.5307 39.5883C32.1427 39.1654 32.5832 38.4967 32.6196 37.7374C32.6167 36.9413 31.8876 36.5756 31.2141 36.4171Z",
  fill: "#67EDFF"
});

function SvgNotification(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 50,
    viewBox: "0 0 56 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "assets/media/Notification.b945ed1d.svg";
export { ForwardRef as ReactComponent };